import { gsap, Power1, Power0 } from 'gsap'
import { startScroll, killPreloader } from '../timeline'

function runTimelinePreloader()
{
  $('header').fadeOut()
  /* Timeline preloader */
  let preloader = $('.timeline-preloader')
  let nextButton = preloader.find('.js-open-timeline')
  let preloaderDuration = 2

  $('#timeline-els [data-style]').each(function (e){
    $(this).attr('style', $(this).attr('data-style'))
  })


  $('.js-open-btn-container').hide()

  if(preloader.length) {

    gsap.from($('.colored-number-animate'), {keyframes:[
          {clipPath: "polygon(0 0, 100% 0, 100% 90%, 0 90%)"},
          {clipPath: "polygon(0 0, 100% 0, 100% 6%, 0 6%)"},
        ],
        duration: preloaderDuration,
        ease: Power1.easeOut,
        onComplete: function(){
          $('.loading-percent').fadeOut('fast', function (){
            $('.js-open-btn-container').css('height', $('.loading-percent').height() + 'px')
            $('.js-open-btn-container').show()
            $('.js-open-timeline').addClass('visible')

          })
        },
      }
    );

    gsap.to($('.loader-get-percent'), {
      duration: preloaderDuration,
      opacity: 1,
      ease: Power0.easeNone,
      onUpdate: function () {
        $('.preload-number').text(parseInt(this.targets()[0].style["opacity"] * 100))
      }
    })

    $('body').on('click', '.js-open-timeline', function (e){
      e.preventDefault()

      //startScroll()
      animateOut()
    })


  }
}

function animateOut() {
  gsap.to($('#timeline-preloader'),
    {
      y: '-100%',
      duration: 1,
      onComplete: killPreloader
    })
}

export { runTimelinePreloader }